// projects/pwa/src/ach/tax-payments/containers/tax-payment-workflow-container.data.ts
export const TAX_PAYMENT_WORKFLOW_CONTAINER_TAG_NAME = 'tax-payment-workflow-container';
